


































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import AccountInfoVue from "@/components/AccountBookList/AccountInfo.vue";
import version from "@/version";

@Component({
  ...mapGetters(["accountBook"]),
  components: {
    "account-info": AccountInfoVue
  }
})
export default class ViewAccountBook extends Vue {
  @Prop({ type: Boolean, default: false })
  visible!: boolean;

  @Prop({ type: Boolean, default: false })
  isChange!: boolean;

  @Prop({ type: Boolean, default: false })
  isAccountVal!: boolean;

  @Prop({ type: Object, default: null })
  bookData!: AccountBookList.AccountBook | null;

  bookDataCopy: AccountBookList.AccountBook = this.$store.state.accountBook;
  visibleCopy: boolean = this.visible;

  @Watch("visibleCopy")
  visibleCopyChange(val: boolean) {
    this.$emit("update:visible", val);
  }

  @Watch("visible")
  visibleChange(val: boolean) {
    this.visibleCopy = val;
  }

  @Watch("bookData")
  bookDataChange(val: AccountBookList.AccountBook) {
    this.bookDataCopy = val;
  }

  mounted() {
    if (this.bookData != null) {
      this.bookDataCopy = this.bookData;
    } else {
      this.bookDataCopy = this.$store.state.accountBook;
    }
  }

  editSuccess() {
    this.visibleCopy = false;
    this.$emit("success");
  }

  exportBook() {
    const url = `${Vue.axios.defaults.baseURL}export/download?accountBookId=${this.bookDataCopy.id}&token=${this.$store.state.account.token}&version=${version}&accounterId=${this.$store.state.account.id}`;
    this.$store.dispatch("toggleDownload", true);
    this.$utils.sendToElectron("download", url);
  }
}
